import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import type { TModel } from './SettingsModelSelect';

type SettingsModelMenuProps = {
  mockModel: TModel;
};

export default function SettingsModelMenu({ mockModel }: SettingsModelMenuProps) {
  const model = mockModel;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '600px',
        p: 2,
        borderRadius: 2,
        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
        pointerEvents: 'auto',
      }}
    >
      {/* Header */}
      <Stack direction="column">
        <Link
          href={model.link}
          target="_blank"
          rel="noopener"
          underline="hover"
          sx={{
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          <Typography variant="h6" fontWeight={600} color="primary">
            {model.name}
          </Typography>
        </Link>

        {model.description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 0.5,
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              hyphens: 'auto',
              lineHeight: 1.4,
            }}
          >
            {model.description}
          </Typography>
        )}
      </Stack>

      <Divider sx={{ my: 2 }} />
      {/* file support */}
      {model.fileTypeSupport && (
        <Box>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Supported file types
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {model.fileTypeSupport.length > 0 ? (
              model.fileTypeSupport.map((type, i) => (
                <Chip key={i} label={type.label} size="small" />
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                No file support
              </Typography>
            )}
          </Stack>
        </Box>
      )}

      <Divider sx={{ my: 2 }} />

      {/* Footer */}
      <Stack
        direction="row"
        spacing={3}
        alignItems="center"
        divider={<Divider orientation="vertical" flexItem />}
      >
        {/* Knowledge Cutoff */}
        {model.knowledgeCutoff && (
          <Box flex={1} sx={{ display: 'flex', gap: 1 }}>
            <Typography variant="subtitle2" color="text.secondary">
              Knowledge cutoff:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {model.knowledgeCutoff}
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
}
